export interface FileTypeConfig {
  color: string;
  bg: string;
  label: string;
  icon: string;
}

export const FILE_TYPE_CONFIG: Record<string, FileTypeConfig> = {
  "application/pdf": {
    color: "#A32D2D",
    bg: "#FCEBEB",
    label: "PDF",
    icon: "FilePdfOutlined",
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    color: "#3B6D11",
    bg: "#EAF3DE",
    label: "XLS",
    icon: "FileExcelOutlined",
  },
  "application/vnd.ms-excel": {
    color: "#3B6D11",
    bg: "#EAF3DE",
    label: "XLS",
    icon: "FileExcelOutlined",
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    color: "#185FA5",
    bg: "#E6F1FB",
    label: "DOC",
    icon: "FileWordOutlined",
  },
  "application/msword": {
    color: "#185FA5",
    bg: "#E6F1FB",
    label: "DOC",
    icon: "FileWordOutlined",
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
    color: "#D85A30",
    bg: "#FAECE7",
    label: "PPT",
    icon: "FilePptOutlined",
  },
  "application/vnd.ms-powerpoint": {
    color: "#D85A30",
    bg: "#FAECE7",
    label: "PPT",
    icon: "FilePptOutlined",
  },
  "image/png": {
    color: "#534AB7",
    bg: "#EEEDFE",
    label: "PNG",
    icon: "FileImageOutlined",
  },
  "image/jpeg": {
    color: "#534AB7",
    bg: "#EEEDFE",
    label: "JPG",
    icon: "FileImageOutlined",
  },
  "image/gif": {
    color: "#534AB7",
    bg: "#EEEDFE",
    label: "GIF",
    icon: "FileImageOutlined",
  },
  "image/webp": {
    color: "#534AB7",
    bg: "#EEEDFE",
    label: "WEBP",
    icon: "FileImageOutlined",
  },
  "image/svg+xml": {
    color: "#534AB7",
    bg: "#EEEDFE",
    label: "SVG",
    icon: "FileImageOutlined",
  },
  "text/csv": {
    color: "#3B6D11",
    bg: "#EAF3DE",
    label: "CSV",
    icon: "FileTextOutlined",
  },
  "text/plain": {
    color: "#5F5E5A",
    bg: "#F1EFE8",
    label: "TXT",
    icon: "FileTextOutlined",
  },
  "text/markdown": {
    color: "#5F5E5A",
    bg: "#F1EFE8",
    label: "MD",
    icon: "FileMarkdownOutlined",
  },
  "application/zip": {
    color: "#BA7517",
    bg: "#FAEEDA",
    label: "ZIP",
    icon: "FileZipOutlined",
  },
  "application/x-zip-compressed": {
    color: "#BA7517",
    bg: "#FAEEDA",
    label: "ZIP",
    icon: "FileZipOutlined",
  },
  "application/x-rar-compressed": {
    color: "#BA7517",
    bg: "#FAEEDA",
    label: "RAR",
    icon: "FileZipOutlined",
  },
  "video/mp4": {
    color: "#993556",
    bg: "#FBEAF0",
    label: "MP4",
    icon: "VideoCameraOutlined",
  },
  "video/webm": {
    color: "#993556",
    bg: "#FBEAF0",
    label: "WEBM",
    icon: "VideoCameraOutlined",
  },
  "video/quicktime": {
    color: "#993556",
    bg: "#FBEAF0",
    label: "MOV",
    icon: "VideoCameraOutlined",
  },
  "audio/mpeg": {
    color: "#993556",
    bg: "#FBEAF0",
    label: "MP3",
    icon: "AudioOutlined",
  },
  "audio/wav": {
    color: "#993556",
    bg: "#FBEAF0",
    label: "WAV",
    icon: "AudioOutlined",
  },
  default: {
    color: "#5F5E5A",
    bg: "#F1EFE8",
    label: "FILE",
    icon: "FileOutlined",
  },
};

export function getFileConfig(mimeType: string): FileTypeConfig {
  return FILE_TYPE_CONFIG[mimeType] || FILE_TYPE_CONFIG["default"];
}

export function getFileExtension(fileName: string): string {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : "";
}

export function getMimeTypeFromExtension(extension: string): string {
  const extensionMap: Record<string, string> = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    csv: "text/csv",
    txt: "text/plain",
    md: "text/markdown",
    zip: "application/zip",
    rar: "application/x-rar-compressed",
    mp4: "video/mp4",
    webm: "video/webm",
    mov: "video/quicktime",
    mp3: "audio/mpeg",
    wav: "audio/wav",
  };

  return extensionMap[extension.toLowerCase()] || "application/octet-stream";
}
